
var id = "Retention";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"Retention\">\n<style type=\"text/css\">\n\t#Retention .st0{fill:'';}\n</style>\n<title>&lt;svg t=&quot;1634287476088&quot; class=&quot;icon&quot; viewBox=&quot;0 0 1</title>\n<g id=\"Retention_Page-1\">\n\t<g id=\"Retention_品牌健康中心-新-copy\" transform=\"translate(-711.000000, -1000.000000)\">\n\t\t\n\t\t\t<g transform=\"translate(721.000000, 1010.000000) rotate(-180.000000) translate(-721.000000, -1010.000000) translate(711.000000, 1000.000000)\">\n\t\t\t<path id=\"Retention_Shape\" class=\"st0\" d=\"M2.2,0H0v20h2.2V0z M8.9,0h2.2v2.2H8.9V0z M8.9,4.4h2.2v2.2H8.9V4.4z M6.7,4.4H4.4v2.2h2.2V4.4z\n\t\t\t\t M4.4,0h2.2v2.2H4.4V0z M6.7,13.3H4.4v2.2h2.2V13.3z M8.9,8.9h2.2v2.2H8.9V8.9z M6.7,8.9H4.4v2.2h2.2V8.9z M13.3,4.4h2.2v2.2\n\t\t\t\th-2.2V4.4z M15.6,0h-2.2v2.2h2.2V0z M17.8,0H20v2.2h-2.2V0z\" />\n\t\t</g>\n\t</g>\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
